/**
 * Compras que se muestran en el aviso flotante.
 * Reemplazá estos ejemplos por compras reales antes de publicar
 * (mostrar compras inventadas puede considerarse publicidad engañosa).
 */
export const recentPurchases = [
  { initials: 'M. G.', city: 'Córdoba', timeAgo: 'hace 3 minutos' },
  { initials: 'L. R.', city: 'Rosario, Santa Fe', timeAgo: 'hace 7 minutos' },
  { initials: 'C. P.', city: 'Mendoza', timeAgo: 'hace 12 minutos' },
  { initials: 'V. S.', city: 'La Plata, Buenos Aires', timeAgo: 'hace 18 minutos' },
  { initials: 'A. F.', city: 'San Miguel de Tucumán', timeAgo: 'hace 25 minutos' },
  { initials: 'J. M.', city: 'Mar del Plata, Buenos Aires', timeAgo: 'hace 31 minutos' },
  { initials: 'S. B.', city: 'Neuquén', timeAgo: 'hace 40 minutos' },
  { initials: 'R. D.', city: 'Salta', timeAgo: 'hace 52 minutos' },
  { initials: 'N. T.', city: 'CABA', timeAgo: 'hace 1 hora' },
];
